export const extractIdFromSlug = (slug: string | null): number | null => {
  if (!slug) return null;

  const parts = slug.split('-');
  const last = parts[parts.length - 1];

  const id = Number(last);
  return Number.isInteger(id) ? id : null;
};
